module.exports = __webpack_public_path__ + "media/8.deb0dcbf.wav";